import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { VipDiscountListByCompanyResponse } from '@app/api/marketplace/models';
import { VipDiscountsService } from '@app/api/marketplace/services';

import { VipDiscountsBuyingActions } from './vip-discounts.slice';

@Injectable({ providedIn: 'root' })
export class VipDiscountsBuyingEffects {
  loadDiscountsReceived$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VipDiscountsBuyingActions.loadDiscountsReceived.trigger),
      switchMap((action) => {
        return this.discountService
          .getReceivedVipDiscountsByCompany({ page: 0, size: 1000 })
          .pipe(
            map((response: Array<VipDiscountListByCompanyResponse>) =>
              VipDiscountsBuyingActions.loadDiscountsReceived.success({
                response,
              })
            ),
            catchError(() =>
              of(VipDiscountsBuyingActions.loadDiscountsReceived.failure())
            )
          );
      })
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly discountService: VipDiscountsService
  ) {}
}
